<script>
import {
  WECHAT_COMPONENT_API,
  WECHAT_MP_ACTION,
  buildWechatAppCallbackUrl,
  resolveAccountUid,
  menuFromWechat,
  menuToWechat,
  validateWechatMenuRows,
} from "@/utils/wechat-official-account";

function openidHeaders(user) {
  const openid = user && user.openid;
  return openid ? { Openid: openid } : {};
}

function pickData(res) {
  const body = res && res.data;
  if (!body) return null;
  if (body.data !== undefined) return body.data;
  return body;
}

export default {
  name: "WechatOfficialAccountManage",
  data() {
    return {
      activeTab: "cfg",
      userinfo: {},
      configForm: {
        appid: "",
        appsecret: "",
        encoding_aes_key: "",
        token: "",
      },
      configFlags: {
        has_appsecret: false,
        has_encoding_aes_key: false,
        has_token: false,
      },
      configLoading: false,
      saveConfigLoading: false,
      authLoading: false,
      authUri: "",
      menuRows: [],
      menuLoading: false,
      menuSaving: false,
      menuJsonMode: false,
      menuJsonText: "",
    };
  },
  computed: {
    accountUid() {
      return resolveAccountUid(this.userinfo);
    },
    serverCallbackUrl() {
      return buildWechatAppCallbackUrl(this.accountUid);
    },
    axiosHeaders() {
      return { headers: openidHeaders(this.userinfo) };
    },
  },
  mounted() {
    try {
      this.userinfo = JSON.parse(localStorage.getItem("user") || "null") || {};
    } catch (e) {
      this.userinfo = {};
    }
    this.loadConfig();
  },
  methods: {
    ensureLogin() {
      if (!this.userinfo.openid) {
        this.$message.warning("请先登录（需要 Openid）");
        return false;
      }
      return true;
    },
    async copyText(text) {
      if (!text) return;
      try {
        await navigator.clipboard.writeText(text);
        this.$message.success("已复制");
      } catch (e) {
        this.$alert(text, "请手动复制", { confirmButtonText: "确定" });
      }
    },
    async loadConfig() {
      if (!this.ensureLogin()) return;
      this.configLoading = true;
      try {
        const res = await this.$axios.post(
          WECHAT_COMPONENT_API,
          { action: WECHAT_MP_ACTION.GET_CONFIG },
          this.axiosHeaders
        );
        const d = pickData(res) || {};
        this.configForm.appid = d.appid || d.AppId || "";
        this.configFlags.has_appsecret = !!(d.has_appsecret || d.has_app_secret);
        this.configFlags.has_encoding_aes_key = !!(
          d.has_encoding_aes_key || d.encoding_aes_key_set
        );
        this.configFlags.has_token = !!(d.has_token || d.token_set);
        if (d.encoding_aes_key && !this.configFlags.has_encoding_aes_key) {
          this.configForm.encoding_aes_key = d.encoding_aes_key;
        }
        if (d.token && !this.configFlags.has_token) {
          this.configForm.token = d.token;
        }
      } catch (e) {
        console.error(e);
        this.$message.error("读取公众号配置失败（请确认后端已实现 comwechat.get_config）");
      } finally {
        this.configLoading = false;
      }
    },
    async saveConfig() {
      if (!this.ensureLogin()) return;
      if (!this.configForm.appid || !String(this.configForm.appid).trim()) {
        this.$message.warning("请填写 AppID");
        return;
      }
      this.saveConfigLoading = true;
      try {
        const res = await this.$axios.post(
          WECHAT_COMPONENT_API,
          {
            action: WECHAT_MP_ACTION.SAVE_CONFIG,
            appid: String(this.configForm.appid).trim(),
            appsecret: String(this.configForm.appsecret || "").trim(),
            encoding_aes_key: String(this.configForm.encoding_aes_key || "").trim(),
            token: String(this.configForm.token || "").trim(),
          },
          this.axiosHeaders
        );
        const body = res.data;
        if (body && Number(body.status) === 200) {
          this.$message.success("保存成功");
          this.configForm.appsecret = "";
          await this.loadConfig();
        } else {
          this.$message.error((body && (body.errmsg || body.message)) || "保存失败");
        }
      } catch (e) {
        console.error(e);
        this.$message.error("保存失败");
      } finally {
        this.saveConfigLoading = false;
      }
    },
    async startOAuth() {
      if (!this.ensureLogin()) return;
      this.authLoading = true;
      this.authUri = "";
      try {
        const res = await this.$axios.post(
          WECHAT_COMPONENT_API,
          { action: WECHAT_MP_ACTION.AUTH_URI, auth_type: 1 },
          this.axiosHeaders
        );
        const body = res.data;
        const uri = body.uri || (body.data && body.data.uri);
        if (uri) {
          this.authUri = uri;
          window.open(uri, "_blank", "noopener,noreferrer");
          this.$message.success("已打开授权页，完成后请在本页保存配置并刷新菜单");
        } else {
          const res2 = await this.$axios.post(
            WECHAT_COMPONENT_API,
            { action: WECHAT_MP_ACTION.AUTH_URI },
            this.axiosHeaders
          );
          const uri2 = res2.data.uri || (res2.data.data && res2.data.data.uri);
          if (uri2) {
            this.authUri = uri2;
            window.open(uri2, "_blank", "noopener,noreferrer");
            this.$message.warning("已打开默认授权页（若需仅公众号请在后端支持 auth_type）");
          } else {
            this.$message.error("未获取到授权链接");
          }
        }
      } catch (e) {
        console.error(e);
        this.$message.error("获取授权链接失败");
      } finally {
        this.authLoading = false;
      }
    },
    openAuthAgain() {
      if (this.authUri) window.open(this.authUri, "_blank", "noopener,noreferrer");
    },
    emptyLeaf() {
      return {
        type: "view",
        name: "",
        key: "",
        url: "",
        appid: "",
        pagepath: "",
      };
    },
    emptySubMenuRow() {
      return { isSubMenu: true, name: "", children: [this.emptyLeaf()] };
    },
    emptyTopLeafRow() {
      return { isSubMenu: false, ...this.emptyLeaf(), children: [] };
    },
    addTopMenu() {
      if (this.menuRows.length >= 3) {
        this.$message.warning("一级菜单最多 3 个");
        return;
      }
      this.menuRows.push(this.emptyTopLeafRow());
    },
    removeTopMenu(i) {
      this.menuRows.splice(i, 1);
    },
    addSubButton(row) {
      if (!row.children) this.$set(row, "children", []);
      if (row.children.length >= 5) {
        this.$message.warning("子菜单最多 5 个");
        return;
      }
      row.children.push(this.emptyLeaf());
    },
    removeSubButton(row, j) {
      row.children.splice(j, 1);
    },
    onTopKindChange(row) {
      this.$nextTick(() => {
        if (row.isSubMenu) {
          if (!row.children || !row.children.length) {
            const c = this.emptyLeaf();
            c.type = row.type || "view";
            c.key = row.key || "";
            c.url = row.url || "";
            c.appid = row.appid || "";
            c.pagepath = row.pagepath || "";
            this.$set(row, "children", [c]);
          }
        } else {
          const first = (row.children && row.children[0]) || this.emptyLeaf();
          row.type = first.type || "view";
          row.key = first.key || "";
          row.url = first.url || "";
          row.appid = first.appid || "";
          row.pagepath = first.pagepath || "";
          this.$set(row, "children", []);
        }
      });
    },
    async fetchMenuFromWechat() {
      if (!this.ensureLogin()) return;
      this.menuLoading = true;
      try {
        const res = await this.$axios.post(
          WECHAT_COMPONENT_API,
          { action: WECHAT_MP_ACTION.GET_MENU },
          this.axiosHeaders
        );
        const raw = pickData(res);
        const menuPayload =
          raw && (raw.menu || raw.selfmenu_info || raw)
            ? raw.menu || raw.selfmenu_info || raw
            : raw;
        this.menuRows = menuFromWechat(menuPayload);
        this.menuJsonText = JSON.stringify(menuToWechat(this.menuRows), null, 2);
        this.$message.success("已从服务器拉取菜单");
      } catch (e) {
        console.error(e);
        this.$message.error("拉取菜单失败（请确认已配置 AppID/Secret 且后端实现 comwechat.get_menu）");
      } finally {
        this.menuLoading = false;
      }
    },
    applyMenuJson() {
      try {
        const o = JSON.parse(this.menuJsonText || "{}");
        this.menuRows = menuFromWechat(o);
        this.$message.success("已解析 JSON");
        this.menuJsonMode = false;
      } catch (e) {
        this.$message.error("JSON 格式错误");
      }
    },
    syncJsonFromRows() {
      this.menuJsonText = JSON.stringify(menuToWechat(this.menuRows), null, 2);
    },
    async saveMenuToWechat() {
      if (!this.ensureLogin()) return;
      let payload;
      if (this.menuJsonMode) {
        try {
          payload = JSON.parse(this.menuJsonText || "{}");
        } catch (e) {
          this.$message.error("JSON 格式错误");
          return;
        }
      } else {
        if (!this.menuRows.length) {
          this.$message.warning("请先添加一级菜单或使用 JSON 编辑");
          return;
        }
        payload = menuToWechat(this.menuRows);
      }
      const err = validateWechatMenuRows(menuFromWechat(payload));
      if (err) {
        this.$message.warning(err);
        return;
      }
      this.menuSaving = true;
      try {
        const res = await this.$axios.post(
          WECHAT_COMPONENT_API,
          {
            action: WECHAT_MP_ACTION.SET_MENU,
            menu: typeof payload === "string" ? payload : JSON.stringify(payload),
          },
          this.axiosHeaders
        );
        const body = res.data;
        if (body && Number(body.status) === 200) {
          this.$message.success("菜单已提交至微信");
        } else {
          this.$message.error((body && (body.errmsg || body.message)) || "保存失败");
        }
      } catch (e) {
        console.error(e);
        this.$message.error("保存菜单失败");
      } finally {
        this.menuSaving = false;
      }
    },
  },
};
</script>

<template>
  <div class="wx-mp-manage">
    <el-tabs v-model="activeTab" type="border-card">
      <el-tab-pane label="接入配置" name="cfg">
        <div v-loading="configLoading" class="wx-mp-pane">
          <el-alert
            title="服务器配置（微信公众平台 → 基本配置 / 服务器配置）"
            type="info"
            :closable="false"
            show-icon
            class="wx-mp-alert"
          >
            <p>将下列 URL 填写为「服务器地址(URL)」，Token、EncodingAESKey 与本页保存的一致；消息加密方式与后台约定一致（建议安全模式）。</p>
            <p class="wx-mp-url-line">
              <code>{{ serverCallbackUrl }}</code>
              <el-button type="text" size="small" @click="copyText(serverCallbackUrl)">复制</el-button>
            </p>
            <p v-if="!accountUid" class="text-warning mb-0">
              当前登录信息中缺少账户 UID（id / uid / openid），无法生成 key 参数，请检查登录接口返回字段。
            </p>
          </el-alert>

          <div class="card border-0 shadow-sm mb-3">
            <div class="card-body">
              <h6 class="wx-mp-card-title">方式一：填写开发者凭据</h6>
              <p class="text-muted small">
                AppSecret、EncodingAESKey、Token 提交后由服务端存储；再次保存时若留空则通常表示不修改原值（以后端实现为准）。
              </p>
              <el-form label-width="140px" size="small" class="wx-mp-form">
                <el-form-item label="AppID" required>
                  <el-input v-model="configForm.appid" placeholder="wx 开头的公众号 AppID" clearable />
                </el-form-item>
                <el-form-item label="AppSecret">
                  <el-input
                    v-model="configForm.appsecret"
                    type="password"
                    show-password
                    :placeholder="configFlags.has_appsecret ? '已配置，留空则不修改' : '请输入 AppSecret'"
                    clearable
                  />
                </el-form-item>
                <el-form-item label="EncodingAESKey">
                  <el-input
                    v-model="configForm.encoding_aes_key"
                    type="password"
                    show-password
                    :placeholder="configFlags.has_encoding_aes_key ? '已配置，留空则不修改' : '43 位消息加密密钥'"
                    clearable
                  />
                </el-form-item>
                <el-form-item label="Token">
                  <el-input
                    v-model="configForm.token"
                    type="password"
                    show-password
                    :placeholder="configFlags.has_token ? '已配置，留空则不修改' : '自定义 Token，与公众平台一致'"
                    clearable
                  />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :loading="saveConfigLoading" @click="saveConfig">
                    保存配置
                  </el-button>
                  <el-button @click="loadConfig">重新加载</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>

          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <h6 class="wx-mp-card-title">方式二：第三方平台授权（可选）</h6>
              <p class="text-muted small">
                若已开通开放平台第三方应用，可扫码授权后由服务端写入凭据；仍须将上方服务器 URL 配置到公众号后台。
              </p>
              <el-button type="default" :loading="authLoading" icon="el-icon-link" @click="startOAuth">
                获取授权链接并打开
              </el-button>
              <el-button v-if="authUri" type="text" @click="openAuthAgain">再次打开</el-button>
              <el-button v-if="authUri" type="text" @click="copyText(authUri)">复制链接</el-button>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="自定义菜单" name="menu">
        <div class="wx-mp-pane">
          <div class="wx-mp-menu-toolbar">
            <div>
              <el-button type="primary" size="small" :loading="menuLoading" icon="el-icon-download" @click="fetchMenuFromWechat">
                从微信拉取
              </el-button>
              <el-button type="success" size="small" :loading="menuSaving" icon="el-icon-upload2" @click="saveMenuToWechat">
                保存到微信
              </el-button>
              <el-button size="small" @click="addTopMenu">新增一级菜单</el-button>
              <el-button size="small" @click="menuJsonMode = !menuJsonMode">
                {{ menuJsonMode ? "可视化编辑" : "JSON 编辑" }}
              </el-button>
            </div>
            <span class="text-muted small">一级最多 3 个；含子菜单时子项 1～5 个</span>
          </div>

          <el-input
            v-if="menuJsonMode"
            v-model="menuJsonText"
            type="textarea"
            :rows="18"
            class="wx-mp-json"
            placeholder='{"button":[...]}'
          />
          <div v-if="menuJsonMode" class="mt-2">
            <el-button size="small" type="primary" @click="applyMenuJson">解析到表单</el-button>
            <el-button size="small" @click="syncJsonFromRows">从表单生成 JSON</el-button>
          </div>

          <div v-else class="wx-mp-menu-list">
            <div v-for="(row, i) in menuRows" :key="'top-' + i" class="wx-mp-menu-block card shadow-sm">
              <div class="card-body">
                <div class="wx-mp-menu-block-head">
                  <span class="wx-mp-badge">一级 {{ i + 1 }}</span>
                  <el-button type="text" class="text-danger" @click="removeTopMenu(i)">删除</el-button>
                </div>
                <el-form label-width="100px" size="small">
                  <el-form-item label="菜单名称">
                    <el-input v-model="row.name" maxlength="16" show-word-limit placeholder="4–8 个汉字为宜" />
                  </el-form-item>
                  <el-form-item label="类型">
                    <el-radio-group v-model="row.isSubMenu" size="small" @change="onTopKindChange(row)">
                      <el-radio :label="false">直接点击</el-radio>
                      <el-radio :label="true">含子菜单</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <template v-if="!row.isSubMenu">
                    <el-form-item label="响应类型">
                      <el-select v-model="row.type" style="width: 160px">
                        <el-option label="跳转网页 view" value="view" />
                        <el-option label="点击推事件 click" value="click" />
                        <el-option label="打开小程序 miniprogram" value="miniprogram" />
                      </el-select>
                    </el-form-item>
                    <el-form-item v-if="row.type === 'click'" label="Key">
                      <el-input v-model="row.key" placeholder="事件 KEY" />
                    </el-form-item>
                    <el-form-item v-if="row.type === 'view'" label="网页链接">
                      <el-input v-model="row.url" placeholder="https://..." />
                    </el-form-item>
                    <template v-if="row.type === 'miniprogram'">
                      <el-form-item label="小程序 appid">
                        <el-input v-model="row.appid" />
                      </el-form-item>
                      <el-form-item label="页面路径">
                        <el-input v-model="row.pagepath" placeholder="pages/index/index" />
                      </el-form-item>
                      <el-form-item label="备用网页">
                        <el-input v-model="row.url" placeholder="低版本微信打开，需 http 链接" />
                      </el-form-item>
                    </template>
                  </template>

                  <template v-else>
                    <div class="wx-mp-sub-list">
                      <div v-for="(sub, j) in row.children" :key="'sub-' + i + '-' + j" class="wx-mp-sub-item">
                        <div class="wx-mp-sub-head">
                          <span>子菜单 {{ j + 1 }}</span>
                          <el-button type="text" class="text-danger" @click="removeSubButton(row, j)">删除</el-button>
                        </div>
                        <el-form-item label="名称">
                          <el-input v-model="sub.name" maxlength="16" show-word-limit />
                        </el-form-item>
                        <el-form-item label="类型">
                          <el-select v-model="sub.type" style="width: 160px">
                            <el-option label="view" value="view" />
                            <el-option label="click" value="click" />
                            <el-option label="miniprogram" value="miniprogram" />
                          </el-select>
                        </el-form-item>
                        <el-form-item v-if="sub.type === 'click'" label="Key">
                          <el-input v-model="sub.key" />
                        </el-form-item>
                        <el-form-item v-if="sub.type === 'view'" label="链接">
                          <el-input v-model="sub.url" />
                        </el-form-item>
                        <template v-if="sub.type === 'miniprogram'">
                          <el-form-item label="appid">
                            <el-input v-model="sub.appid" />
                          </el-form-item>
                          <el-form-item label="路径">
                            <el-input v-model="sub.pagepath" />
                          </el-form-item>
                          <el-form-item label="备用 url">
                            <el-input v-model="sub.url" />
                          </el-form-item>
                        </template>
                      </div>
                      <el-button size="mini" @click="addSubButton(row)">添加子菜单</el-button>
                    </div>
                  </template>
                </el-form>
              </div>
            </div>
            <div v-if="menuRows.length === 0" class="wx-mp-empty text-muted text-center py-5">
              暂无菜单，请点击「新增一级菜单」或「从微信拉取」
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<style scoped>
.wx-mp-manage {
  margin-top: 0.5rem;
}

.wx-mp-pane {
  padding: 0.5rem 0;
  min-height: 200px;
}

.wx-mp-alert p {
  margin-bottom: 0.35rem;
}

.wx-mp-url-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.wx-mp-url-line code {
  flex: 1;
  min-width: 200px;
  padding: 0.35rem 0.5rem;
  background: #f3f4f6;
  border-radius: 4px;
  font-size: 12px;
  word-break: break-all;
}

.wx-mp-card-title {
  font-weight: 700;
  margin-bottom: 0.75rem;
  color: #1f2937;
}

.wx-mp-form {
  max-width: 640px;
}

.wx-mp-menu-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.wx-mp-menu-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.wx-mp-menu-block-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.wx-mp-badge {
  font-size: 12px;
  font-weight: 600;
  color: #2d6cdf;
}

.wx-mp-sub-list {
  border-left: 3px solid #e5e7eb;
  padding-left: 1rem;
  margin-left: 0.25rem;
}

.wx-mp-sub-item {
  background: #f9fafb;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-bottom: 0.75rem;
}

.wx-mp-sub-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  font-weight: 600;
  font-size: 13px;
}

.wx-mp-json {
  font-family: ui-monospace, monospace;
  font-size: 12px;
}
</style>
